module.exports = __webpack_public_path__ + "img/icon-model-download@2x.8b99d1e7.png";